<template>
  <validation-observer
    ref="graduationRegisterRoundSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="graduationRegisterRoundSaveModal"
      body-class="position-static"
      size="lg"
      centered
      :title="isCreated ? `Thêm đợt xét tốt nghiệp` : `Cập nhật đợt xét tốt nghiệp`"
      no-close-on-backdrop
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="trainingSystemId">
              <template v-slot:label>
                Hệ đào tạo <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Hệ đào tạo"
                rules="required"
              >
                <v-select
                  v-model="targetGraduationRegisterRound.trainingSystemId"
                  label="name"
                  :options="trainingSystems"
                  :reduce="option => option.id"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="yearId">
              <template v-slot:label>
                Năm học <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Năm học"
                rules="required"
              >
                <v-select
                  v-model="targetGraduationRegisterRound.yearId"
                  label="name"
                  :options="years"
                  :reduce="option => option.id"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên đợt xét tốt nghiệp<span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Tên đợt xét tốt nghiệp"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetGraduationRegisterRound.name"
              name="name"
              placeholder="Tên đợt xét tốt nghiệp"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label-for="startDate"
            >
              <template v-slot:label>
                Ngày bắt đầu <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Ngày bắt đầu"
                rules="required"
              >
                <flat-pickr
                  v-model="targetGraduationRegisterRound.startDate"
                  class="form-control"
                  :config="config"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label-for="endDate"
            >
              <template v-slot:label>
                Ngày kết thúc <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Ngày kết thúc"
                rules="required"
              >
                <flat-pickr
                  v-model="targetGraduationRegisterRound.endDate"
                  class="form-control"
                  :config="config"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label-for="startReviewDate"
            >
              <template v-slot:label>
                Ngày bắt đầu xét tốt nghiệp <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Ngày bắt đầu xét tốt nghiệp"
                rules="required"
              >
                <flat-pickr
                  v-model="targetGraduationRegisterRound.startReviewDate"
                  class="form-control"
                  :config="config"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label-for="endReviewDate"
            >
              <template v-slot:label>
                Ngày kết thúc xét tốt nghiệp<span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Ngày kết thúc xét tốt nghiệp"
                rules="required"
              >
                <flat-pickr
                  v-model="targetGraduationRegisterRound.endReviewDate"
                  class="form-control"
                  :config="config"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetGraduationRegisterRound.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('graduationRegisterRoundSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import * as events from 'events'
import { getUser } from '@/auth/utils'
import FlatpickrLanguages from 'flatpickr/dist/l10n'
import flatPickr from 'vue-flatpickr-component'
import { STATUSES } from '@/const/status'

export default {
  name: 'GraduationRegisterRoundSave',
  components: {
    flatPickr,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    graduationRegisterRound: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetGraduationRegisterRound: {
        name: '',
        code: '',
        trainingSystemId: null,
        status: 1,
        yearId: null,
        startDate: null,
        endDate: null,
        startReviewDate: null,
        endReviewDate: null,
      },
      config: {
        enableTime: true,
        altInput: true,
        altFormat: 'd/m/Y H:i',
        dateFormat: 'd/m/Y H:i',
        locale: FlatpickrLanguages.vn,
        time_24hr: true,
      },
      required,
    }
  },
  computed: {
    events() {
      return events
    },
    ...mapGetters({
      trainingSystems: 'graduationRegisterRound/trainingSystems',
      years: 'graduationRegisterRound/years',
    }),
    statusOptions() {
      return STATUSES.map(item => ({ value: item.value, label: item.label }))
    },
    isCreated() {
      return !this.graduationRegisterRound
    },
    getOrganizationId() {
      const cUser = getUser()
      return cUser.orgId ? cUser.orgId : 0
    },
  },
  methods: {
    ...mapActions({
      createGraduationRegisterRound: 'graduationRegisterRound/createGraduationRegisterRound',
      updateGraduationRegisterRound: 'graduationRegisterRound/updateGraduationRegisterRound',
      getTrainingSystems: 'graduationRegisterRound/getTrainingSystemsByOrganizationId',
      getYears: 'graduationRegisterRound/getYears',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    // eslint-disable-next-line consistent-return
    async onShow() {
      this.isLoading = true
      try {
        if (this.graduationRegisterRound) {
          this.targetGraduationRegisterRound = { ...this.graduationRegisterRound }
        }
        await Promise.all([
          this.getTrainingSystems({ organizationId: this.getOrganizationId }),
          this.getYears(),
        ])
        // eslint-disable-next-line no-empty
      } catch (error) {} finally {
        this.isLoading = false
      }
    },
    onHide() {
      this.$refs
        .graduationRegisterRoundSaveFormRef
        .reset()
      this.targetGraduationRegisterRound = {
        name: '',
        code: '',
        trainingSystemId: null,
        status: 1,
        yearId: null,
        startDate: null,
        endDate: null,
        startReviewDate: null,
        endReviewDate: null,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .graduationRegisterRoundSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createGraduationRegisterRound(this.targetGraduationRegisterRound)
            : await this.updateGraduationRegisterRound(this.targetGraduationRegisterRound)
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('graduationRegisterRoundSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
